export default {
    'song':                          'Song',
    'about':                         'About',
    'add-part':                      'Add part',
    'title':                         'Title',
    'author':                        'Author',
    'album':                         'Album',
    'key':                           'Key',
    'timeSignature':                 'Time signature',
    'capo':                          'Capo',
    'tempo':                         'Tempo',
    'part-name':                     'Part name',
    'measure-not-valid':             'Measure not valid',
    'part-deletion':                 'Delete part',
    'part-delete-text1':             'WARNING ! This operation will delete all measures of the part.',
    'part-delete-text2':             'Do you really want to delete the part?',
    'no':                            'No',
    'yes':                           'Yes',
    'add-measure':                   'Add measure',
    'edit-measure':                  'Modify measure',
    'cancel':                        'Cancel',
    'valid':                         'Valid',
    'formula':                       'Formula',
    'alteration':                    'Alteration',
    'root':                          'Root',
    'chord-composition':             'Chord composition',
    'delete-measure':                'Delete measure',
    'time':                          'Time',
    'bass':                          'Bass',
    'open-repeat':                   'Open repeat',
    'close-repeat':                  'Close repeat',
    'repeat':                        'Repeat',
    'repeat-measure':                'Repeat measure',
    'edit':                          'Edit',
    'comment':                       'Comment',
    'french':                        'French',
    'english':                       'English',
    'new-song':                      'New song',
    'songs-list':                    'Songs list',
    'save':                          'Save',
    'home':                          'Home',
    'song-deletion':                 'Delete song',
    'song-delete-text':              'Do you really want to delete the song?',
    'song-not-saved':                'Song not saved',
    'close':                         'Close',
    'display-measure-number':        'Display measure number',
    'measure-number-repeats':        'Number of repeats',
    'cookies-information':           'By continuing your visit to this site, you accept the use of cookies',
    'color':                         'Color',
    'color-measure':                 'Measure color',
    'measure-color-selection':       'Measure color',
    'save-song-error-title':         'Save song error',
    'save-song-error-text':          'You must enter a title',
    'made-with':                     'Made with',
    'visualize-song-home':           'Visualize your songs',
    'print-song-home':               'Print your chords grids',
    'subtitle-home':                 'Easily create your chord grids',
    'description-title-home':        'Chords Grid Editor allows you to easily create and print your favorite chord grids',
    'create-your-song':              'Create your song',
    'you-can-home':                  'You can:',
    'you-can-create-your-song-home': 'You can now create your song',
    'create-edit-grids-home':        'Create / Edit your chords grids',
    'song-information-home':         'Enter information about the song: the key, the capo position and the tempo',
    'colorize-measure-home':         'Colorize measures',
    'use-repeats-home':              'Use repeats',
    'display-measures-number-home':  'Display measures number',
    'versions-history':              'Versions history',
    '0-2-5-title':                   'Add time signature',
    '0-2-5-description':             'Add time signature like song property.',
    '0-2-6-title':                   'Add versions history',
    '0-2-6-description':             'Creation of a page to view the history of the application\'s versions.',
    '0-2-7-title':                   'Minor improvements',
    '0-2-7-description':             '<ul><li>The munimum number of repeats is now 2 instead of 2</li><li>Song formatting</li></ul>',
    'current':                       'current',
    'login-title':                   'Authentication',
    'login':                         'Username',
    'password':                      'Password',
    'invalid-email':                 'Invalid e-mail',
    'required':                      'Required',
    'sign-in':                       'Sign in',
    '0-2-8-title':                   'Minor improvements',
    '0-2-8-description':             '<ul><li>Update packages</li><li>Improve ergonomy</li></ul>',
};
